const DKNUtils = {
  key: "recently_viewed_products",
  storefrontAccessToken: '4c1a76f0f230e695277e1e7821c92fc3',
  apiURL: '/api/2025-01/graphql.json',

  // Discount campaigns cache - populated from collection metaobjects
  discountCampaigns: {},

  addRecentlyViewed: gid => {
    let products = JSON.parse(localStorage.getItem(DKNUtils.key)) || [];
    products = products.filter(id => id !== gid);
    products.unshift(gid);
    if (products.length > 4) products = products.slice(0, 4);
    localStorage.setItem(DKNUtils.key, JSON.stringify(products));
  },

  getRecentlyViewed: () => {
    return JSON.parse(localStorage.getItem(DKNUtils.key)) || [];
  },

  graphqlRequest: async (query) => {
    const res = await fetch(DKNUtils.apiURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': DKNUtils.storefrontAccessToken,
      },
      body: JSON.stringify({ query }),
    });
    if (!res.ok) throw new Error(`GraphQL error: ${res.status}`);
    return res.json();
  },

  // Calculate discount for a product based on variant metafield configuration
  calculateDiscount: (product) => {

    // Get the variant with minimum price (since product shows min price)
    let variant = null;
    let minPrice = Infinity;

    if (product.variants?.edges) {
      for (const edge of product.variants.edges) {
        const v = edge.node;
        const price = parseFloat(v.price.amount);
        if (price < minPrice) {
          minPrice = price;
          variant = v;
        }
      }
    }

    if (!variant) return null;

    // Get tax rate from window (set by Liquid)
    const taxRate = window.shopTaxRate ? (1 + window.shopTaxRate / 100) : 1.1; // Default 10% if not set

    // Prices from GraphQL are without tax, apply tax to match Liquid display
    const basePriceWithoutTax = parseFloat(variant.price.amount);
    const originalPrice = basePriceWithoutTax * taxRate;

    // Check if variant has discount metafield
    const discountMetafield = variant.metafields?.filter(mf => mf !== null).find(
      mf => mf.namespace === 'custom' && mf.key === 'discount_campaign'
    );

    // Apply discount if metafield exists and references a metaobject
    if (discountMetafield && discountMetafield.reference) {
      const campaignData = discountMetafield.reference;
      const percentField = campaignData.fields?.find(f => f.key === 'percentage');
      const percent = percentField ? parseInt(percentField.value) : 0;

      if (percent > 0) {
        // Apply discount to base price first, then add tax
        const discountedBasePrice = basePriceWithoutTax * (100 - percent) / 100;
        const discountedPrice = discountedBasePrice * taxRate;

        return {
          hasDiscount: true,
          originalPrice,
          discountedPrice,
          discountPercent: percent
        };
      }
    }

    // Check if variant has compareAtPrice
    if (variant.compareAtPrice?.amount) {
      const compareAtBase = parseFloat(variant.compareAtPrice.amount);
      const compareAt = compareAtBase * taxRate;
      const price = basePriceWithoutTax * taxRate;

      if (compareAt > price) {
        return {
          hasDiscount: true,
          originalPrice: compareAt,
          discountedPrice: price
        };
      }
    }

    return null;
  },

  // Format price for display
  formatPrice: (price) => {
    return Math.floor(price).toLocaleString();
  }
};
function setEqualTitleHeight(perRow = 2) {
    var $items = $('.c-comment__item');
    var $titles = $items.find('.c-comment__title');
    $titles.css('height', 'auto');
    for (var i = 0; i < $items.length; i += perRow) {
      var $rowItems = $items.slice(i, i + perRow);
      var maxH = 0;
      $rowItems.each(function () {
        var h = $(this).find('.c-comment__title').outerHeight();
        if (h > maxH) maxH = h;
      });
      $rowItems.each(function () {
        $(this).find('.c-comment__title').height(maxH);
      });
    }
}

$(window).on('load resize', function () {
  setEqualTitleHeight(2);
});
function toggleHeaderOnScroll() {
  const $header = $('.l-header');
  const headerHeight = $header.outerHeight();
  let scrollTimer = null;

  $(window).on('scroll', function() {
    const currentScroll = $(this).scrollTop();

    if (currentScroll > headerHeight) {
      $header.addClass('is-hide');

      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        $header.removeClass('is-hide');
      }, 200);
    } else {
      $header.removeClass('is-hide');
    }
  });
}

toggleHeaderOnScroll();
function toggleFooterOnScroll() {
  const $footer = $('.bottom-menu');
  const footerHeight = $footer.outerHeight();
  let scrollTimer = null;

  $(window).on('scroll', function() {
    const scrollTop = $(this).scrollTop();

    // Nếu cuộn vượt qua chiều cao footer thì mới áp dụng ẩn/hiện
    if (scrollTop > footerHeight) {
      // Đang scroll → ẩn footer
      $footer.addClass('is-hide');

      // Khi dừng scroll (sau 200ms) → hiện lại
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        $footer.removeClass('is-hide');
      }, 200);
    } else {
      // Ở đầu trang → luôn hiện footer
      $footer.removeClass('is-hide');
    }
  });
}

toggleFooterOnScroll();

